import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import appConfig from '../../config/appConfig';
import * as routeParams from '../../consts/route/routeParams';
import marketTypeService from '../../services/marketTypeService';
import yapService from '../../services/yap/yapService';
import {selectIotDeviceType} from '../../state/selectors/iotDevice';

const useManualActivation = () => {
    const {[routeParams.DEVICE_TYPE]: type} = useParams();
    const deviceType = useSelector(selectIotDeviceType) || type;
    const isManualActivationEnabled = appConfig.getIsManualActivationEnabled(deviceType);
    const isDCE2 = marketTypeService.isDCE2();
    const isYapEncryptedMode = yapService.isYapEncryptedMode();

    return isManualActivationEnabled && isDCE2 && isYapEncryptedMode;
};

export default useManualActivation;
